import { motion } from "framer-motion";
import { SectionLabel, Reveal, scrollToId } from "../landing/shared";

const LINES = [
  { text: "YOU WEREN'T MISSING", cls: "text-white" },
  { text: "A BETTER RATE.", cls: "text-white/[0.28]" },
  { text: "YOU WERE MISSING", cls: "text-white" },
  { text: "THE WHOLE DEAL.", cls: "text-[#0162CA]" },
];

export default function Recap() {
  let wordIndex = 0;
  return (
    <section className="py-28 lg:py-40 px-6 lg:px-10" data-testid="recap-section">
      <div className="max-w-6xl mx-auto">
        <SectionLabel n="001" text="WHAT YOU JUST LEARNED" />
        <h2
          className="font-black uppercase"
          style={{ fontSize: "clamp(36px, 5vw, 64px)", lineHeight: 0.97, letterSpacing: "-0.02em" }}
          data-testid="recap-statement"
        >
          {LINES.map((line, li) => (
            <span key={li} className={`block ${line.cls}`}>
              {line.text.split(" ").map((w, wi) => {
                const d = wordIndex++ * 0.04;
                return (
                  <motion.span
                    key={wi}
                    className="inline-block mr-[0.28em]"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6, delay: d, ease: [0.22, 1, 0.36, 1] }}
                  >
                    {w}
                  </motion.span>
                );
              })}
            </span>
          ))}
        </h2>
        <Reveal delay={0.3} className="mt-10 max-w-[560px]">
          <p className="text-white/55 text-base leading-[1.75]">
            Here's the heart of what I taught on the class: quotes assembled on different assumptions aren't
            comparable — no matter how confident the lower number looks. Entitlement, an existing property, your
            obligations, and cash-to-close only make sense when they're looked at together, as one transaction. The
            Better Deal Method™ — Clarify → Structure → Guide — exists to look at all of it before a decision, not
            after.
          </p>
          <div className="mt-8">
            <button
              type="button"
              data-cursor="cta"
              data-testid="recap-cta"
              onClick={() => scrollToId("apply")}
              className="cta-outline"
            >
              SEE HOW IT APPLIES TO YOUR SITUATION →
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
